"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesQuoteStatusToJSON = exports.SalesQuoteStatusFromJSONTyped = exports.SalesQuoteStatusFromJSON = exports.SalesQuoteStatus = void 0;
/**
 * The status of the sales quote. This filter is an exact match. Accepted values are 'Created', 'Confirmed', 'Sent', 'Cancelled'.
 * @export
 * @enum {string}
 */
var SalesQuoteStatus;
(function (SalesQuoteStatus) {
    SalesQuoteStatus["CREATED"] = "Created";
    SalesQuoteStatus["CONFIRMED"] = "Confirmed";
    SalesQuoteStatus["SENT"] = "Sent";
    SalesQuoteStatus["CANCELLED"] = "Cancelled";
})(SalesQuoteStatus = exports.SalesQuoteStatus || (exports.SalesQuoteStatus = {}));
function SalesQuoteStatusFromJSON(json) {
    return SalesQuoteStatusFromJSONTyped(json, false);
}
exports.SalesQuoteStatusFromJSON = SalesQuoteStatusFromJSON;
function SalesQuoteStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SalesQuoteStatusFromJSONTyped = SalesQuoteStatusFromJSONTyped;
function SalesQuoteStatusToJSON(value) {
    return value;
}
exports.SalesQuoteStatusToJSON = SalesQuoteStatusToJSON;
